if (!customElements.get('popups-section')) {
    // js/sections/PopupsSection.js
    class PopupsSection extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("[data-popup-type]").forEach((popup) => {
        if (popup.getAttribute("data-popup-type") === "exit") {
            this.exitPopup = new ExitPopup(popup);
        } else if (popup.getAttribute("data-popup-type") === "newsletter") {
            this.newsletterPopup = new NewsletterPopup(popup);
        }
        });
    }
    onUnload() {
        if (this.exitPopup) {
        this.exitPopup.destroy();
        }
        if (this.newsletterPopup) {
        this.newsletterPopup.destroy();
        }
    }
    onBlockSelect(event2) {
        if (event2.target.getAttribute("data-popup-type") === "exit" && this.exitPopup) {
        this.exitPopup._openPopup();
        } else if (event2.target.getAttribute("data-popup-type") === "newsletter" && this.newsletterPopup) {
        this.newsletterPopup._openPopup();
        }
    }
    onBlockDeselect() {
        if (this.exitPopup) {
        this.exitPopup._closePopup();
        }
        if (this.newsletterPopup) {
        this.newsletterPopup._closePopup();
        }
    }
    };
    customElements.define('popups-section', PopupsSection);
}